/* IMPORT */
import { OWNER } from './superroot.js';
import { DIRTY_MAYBE_YES, DIRTY_YES } from '../constants.js';
import { lazyArrayEach, lazyArrayPush, lazySetEach } from '../lazy.js';
import Effect from './effect.js';
import Owner from './owner.js';
import { SYMBOL_SUSPENSE } from '../symbols.js';
import { isFunction } from '../utils.js';
import { callStack, Stack } from '../methods/debugger.js';
/* MAIN */
class Suspense extends Owner {
    /* CONSTRUCTOR */
    constructor() {
        super();
        /* VARIABLES */
        this.parent = OWNER;
        this.context = { ...OWNER.context, [SYMBOL_SUSPENSE]: this };
        lazyArrayPush(this.parent, 'suspenses', this);
        this.suspended = (OWNER.get(SYMBOL_SUSPENSE)?.suspended || 0);
    }
    /* API */
    toggle(force) {
        if (!this.suspended && !force)
            return; // Already suspended, this can happen at instantion time
        const suspendedPrev = this.suspended;
        const suspendedNext = suspendedPrev + (force ? 1 : -1);
        this.suspended = suspendedNext;
        if (!!suspendedPrev === !!suspendedNext)
            return; // Same state, nothing to pause or resume
        /* NOTIFYING OBSERVERS, ROOTS AND SUSPENSES */
        const stack = callStack();
        this.observable?.set(!!suspendedNext);
        const notifyOwner = (owner) => {
            lazyArrayEach(owner.contexts, notifyOwner);
            lazyArrayEach(owner.observers, notifyObserver);
            lazyArrayEach(owner.suspenses, notifySuspense);
            lazySetEach(owner.roots, notifyRoot);
        };
        const notifyObserver = (observer) => {
            if (observer instanceof Effect) {
                if (observer.status === DIRTY_MAYBE_YES || observer.status === DIRTY_YES) {
                    if (observer.init) {
                        observer.update(stack);
                    }
                    else {
                        observer.schedule(stack);
                    }
                }
            }
            notifyOwner(observer);
        };
        const notifyRoot = (root) => {
            if (isFunction(root)) {
                root().forEach(notifyOwner);
            }
            else {
                notifyOwner(root);
            }
        };
        const notifySuspense = (suspense) => {
            suspense.toggle(force);
        };
        notifyOwner(this);
    }
    wrap(fn, owner, observer, stack) {
        return super.wrap(fn, this, undefined, stack);
    }
}
/* EXPORT */
export default Suspense;
